<template>
    <div
        class="inline-block absolute top-3 right-2 text-xl text-color-white cursor-pointer transform"
        :class="showSidebar ? 'rotate-0' : 'rotate-180'"
        @click="$emit('toggleSidebar')"
    >
        <i class="fas fa-arrow-left fa-fw" aria-hidden="true"></i>
    </div>
</template>

<script>

export default {
    emits: ['toggleSidebar'],
    props: ['showSidebar']
}
</script>
